import React from 'react'
import { Card, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  text: string
}

const Tip: React.FC<Props> = ({ text }) => {
  const { t } = useCustomTranslation()

  return (
    <Card sx={theme => ({ paddingInline: theme.spacing(4), paddingBlock: theme.spacing(2), minHeight: 100 })}>
      <Typography variant="h3" pb={2}>
        {t('ai360.tip.title')}
      </Typography>
      <Typography variant="body2">{text}</Typography>
    </Card>
  )
}

export default Tip
